export default __webpack_public_path__ + "fb6a49186828833a224a1cad6963c3b6.png";